import { REFERENTIELS_SET_SORT, REFERENTIELS_SET_PAGINATION, REFERENTIELS_SET_MATCH } from "./../types";

export const setPagination = (page, pages, sectionName) => ({
  type: REFERENTIELS_SET_PAGINATION,
  page,
  pages,
  sectionName
});

/**
 * Set sort
 * @param sectionName
 * @param sort
 * @return {{sectionName: *, sort: *, type: *}}
 */
export const setSort = (sectionName, column, order) => ({
  type: REFERENTIELS_SET_SORT,
  sectionName,
  column,
  order
});

export const setMatchReferentiel = (match, sectionName) => ({
  type: REFERENTIELS_SET_MATCH,
  match,
  sectionName
});

export const getReferentielsList = (data, sectionName) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(setPagination(data.page, state.actions.pages, sectionName));
  };
};

export const init = sectionName => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(setPagination(1, state.actions.pages, sectionName));
  };
};



// WEBPACK FOOTER //
// src/redux/actions/referentielsActions.js